import angular from "angular";

export default angular.module("ppm.ui.app", ["ppm.dependency"]);
